import { BaseService } from '@myhealth-raccoon/services';
import { authService } from '../auth';

class AuthUserService extends BaseService {
    constructor() {
        super('user', import.meta.env.VITE_AUTH_API_URL);
    }

    get Authorization() {
        return authService.Authorization;
    }

    public async EmailGenerateAndSend(email: string) {
        return await this.post('email/generateAndSend', { email });
    }

    public async VerifyEmailUpdate({ email, code }: { email: string; code: string }) {
        return await this.put('email/verify', { email, code });
    }
}

export const authUserService = new AuthUserService();
